import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core'
import { Router } from '@angular/router'

import { User } from '../../shared/user.model'

@Component({
  selector: 'cm-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  styleUrls: ['./toolbar-user.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarUserComponent implements OnInit {

  @Input() user: User

  constructor(private router: Router) { }

  ngOnInit() {

  }

  goToProfile() {
    this.router.navigate(['/profile', this.user.uid])
  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/toolbar/toolbar-user/toolbar-user.component.ts